module.exports = __webpack_public_path__ + "static/avatar.cd0139f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/avatar.jpg
// module id = 227
// module chunks = 114276838955818 198517197184460